import * as _ from 'lodash';

import LANGUAGES_LIST from './languages-list';


export default class LanguageCodeMapper {

  public static getName(code: string): string {
    const codeName = this._codeToLowerCase(code);
    return this.validate(codeName) ? (<any>LANGUAGES_LIST)[codeName].name : '';
  }

  public static getNativeName(code: string): string {
    const codeName = this._codeToLowerCase(code);
    return this.validate(codeName) ? (<any>LANGUAGES_LIST)[codeName].nativeName : '';
  }

  public static getCode(name: string): string {
    const code = _.find(_.keys(LANGUAGES_LIST), (_code: string) => {
      const language = (<any>LANGUAGES_LIST)[_code];
      return language.name.toLowerCase() === name.toLowerCase() ||
             language.nativeName.toLowerCase() === name.toLowerCase();
    });
    return code ? '' : code;
  }

  public static validate(code: string): boolean {
    return (<any>LANGUAGES_LIST)[code] !== undefined;
  }

  private static _codeToLowerCase(code: string): string {
    return code.toLowerCase();
  }
}
